export const MARKETING_EVENTS = {
  appStoreClicked: 'marketing_app_store_clicked',
  installIntent: 'marketing_install_intent',
  campaignAttributed: 'marketing_campaign_attributed',
  sharePressed: 'marketing_share_pressed',
  rateAppPressed: 'marketing_rate_app_pressed',
  updatePromptShown: 'marketing_update_prompt_shown',
  updateAccepted: 'marketing_update_accepted',
  updateDismissed: 'marketing_update_dismissed',
} as const;

export type MarketingEventNameType = (typeof MARKETING_EVENTS)[keyof typeof MARKETING_EVENTS];
